const SectionCard = ({ title, description, children, className = '', contentClassName = '' }) => {
  const hasHeader = Boolean(title || description)
  const content = contentClassName ? <div className={contentClassName}>{children}</div> : children

  return (
    <section className={`bg-white border border-gray-200 rounded-2xl p-4 md:p-6 shadow-sm ${className}`.trim()}>
      {hasHeader && (
        <header className='mb-4'>
          {title && <h3 className='text-lg font-semibold font-sans text-text'>{title}</h3>}
          {description && <p className='text-sm text-muted mt-1'>{description}</p>}
        </header>
      )}
      {content}
    </section>
  )
}

export default SectionCard
